import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-payment",
  "use": "icon-payment-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-payment\"><defs><style type=\"text/css\"></style></defs><path d=\"M899.08 106.24H124.92A59.92 59.92 0 0 0 65 166.16v691.68a59.92 59.92 0 0 0 59.92 59.92h774.16A59.92 59.92 0 0 0 959 857.84V166.16a59.92 59.92 0 0 0-59.92-59.92zM959 655.69H636.09c-80.65 0-146-64-146-142.85 0-78.9 65.38-142.86 146-142.86h322\" p-id=\"52794\" /><path d=\"M646.48 417.06A91.45 91.45 0 0 0 555 508.51v7a91.45 91.45 0 0 0 91.45 91.45h311.67v-189.9z m17.32 134.59a40.58 40.58 0 1 1 40.53-40.58 40.55 40.55 0 0 1-40.53 40.58z\" p-id=\"52795\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/payment.svg
// module id = 3V4M
// module chunks = 7